import { render } from "./Customise.vue?vue&type=template&id=f0c8d546&ts=true"
import script from "./Customise.vue?vue&type=script&lang=ts"
export * from "./Customise.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__